module.exports = __webpack_public_path__ + "static/img/gov.b0449540.png";